export interface NGPReport {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  _tags: string[];
  daysDiff: number;
  dep: string;
  desc: string;
  diffGP: number;
  error: boolean;
  gp1: number;
  isEdited: boolean;
  isSelected: boolean;
  latestCost: number;
  lineColourCode: number;
  nominalGP: number;
  onHand: number;
  onHoldCode: number;
  orderQuantity: number;
  originalValue: Record<string, {value: string | boolean | number | string[]}>;
  packSize: number;
  prevCostPrice: number;
  prevGP: number;
  recommendedGP: number;
  regularSuppCode: string;
  sellPriExcl1: number;
  sellPriIncl1: number;
  subDep: string;
  suppCode: string;
  suppName: string;
  suppUsedLastDate1: Date | null;
  suppUsedLastDate2: Date | null;
  suppUsedLastPrice1: number | null;
  suppUsedLastPrice2: number | null;
  unitsYear: number;
  vatR: number;
  allColumns?: boolean;
  costMiss?: boolean;
  cratedHasSupp1?: boolean;
  created?: boolean;
  createdDate?: Date;
  disabled?: boolean;
  lastStockTake?: Date;
  lineColour?: string;
  lineColourDescription?: string;
  lineColourValue?: string;
  manuallyAdded?: Date;
  modified?: Date;
  newlyAdded?: boolean;
  orderQty?: number;
  stockId?: string;
  store?: string;
  storeId?: string;
}

export const blankNGPReport: NGPReport = {
  stockId: '',
  desc: '',
  newlyAdded: true,
  disabled: false,
  manuallyAdded: new Date(),
  isSelected: false,
  isEdited: false,
  error: false,
  originalValue: {},
  storeId: '',
  store: '',
  latestCost: 0,
  recommendedGP: 0,
  prevCostPrice: 0,
  costMiss: false,
  regularSuppCode: '',
  suppName: '',
  suppCode: '',
  suppUsedLastDate1: new Date(),
  suppUsedLastDate2: new Date(),
  suppUsedLastPrice1: 0,
  suppUsedLastPrice2: 0,
  dep: '',
  subDep: '',
  sellPriIncl1: 0,
  sellPriExcl1: 0,
  gp1: 0,
  diffGP: 0,
  nominalGP: 0,
  prevGP: 0,
  lineColourCode: 0,
  lineColour: '',
  lineColourValue: '',
  lineColourDescription: '',
  packSize: 0,
  vatR: 0,
  daysDiff: 0,
  unitsYear: 0,
  createdDate: new Date(),
  created: false,
  cratedHasSupp1: false,
  onHand: 0,
  onHoldCode: 0,
  orderQuantity: 0,
  // eslint-disable-next-line @typescript-eslint/naming-convention
  _tags: [],
  lastStockTake: null,
  modified: null,
  orderQty: 0,
};
